<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-spinner v-if="!ready" />
        <b-form @submit.prevent="onSubmit()">
          <b-card header="Policies and Procedures Builder" v-show="ready">
            <Loading :active="busy || loading" :is-full-page="false">
              <slot>
                <hm-spinner />
              </slot>
            </Loading>
            <hm-alert />
            <hm-policy :policy="policy" />
            <div ref="policyslot" />
            <hr />
            <div class="text-muted" v-show="policy.createdAt">Last approved: {{policy.createdAt|formatDate('YYYY-MM-DD HH:MM:SS')}}</div>
            <div slot="footer">
              <b-row>
                <b-col cols="6">
                  <b-button type="button" variant="secondary" class="px-4" :disabled="busy" to="/policy-list">Back</b-button>
                  <b-button v-show="policy.createdAt" type="button" variant="primary" class="px-4 ml-2" :disabled="busy" :to="'/print/policy-print/' + id" target="_blank">Print</b-button>
                </b-col>
                <b-col cols="6" class="text-right">
                  <b-button type="submit" variant="primary" class="px-4" :disabled="busy">Approve</b-button>
                  <b-button type="button" variant="primary" class="px-4 ml-2" :disabled="busy" v-show="idNext" @click="onSubmit(idNext)">Approve &amp; Continue</b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { policyService } from '@/services'

export default {
  name: 'PolicyEdit',
  props: ['id'],
  data() {
    return {
      policy: {
        id: '',
        data: {}
      },
      ready: false,
      busy: false,
      submitted: false
    }
  },
  computed: {
    ...mapGetters({
      loading: 'isLoading',
    }),
    idNext() {
      return this.id < '020' ? ('00' + (parseInt(this.id) + 1)).slice(-3) : null;
    },
    policyFile() {
      return 'views/policy/' + this.policy.file;
    }
  },
  methods: {
    ...mapActions({
      alertClear: 'alert/clear',
      alertError: 'alert/error',
      alertException: 'alert/exception',
      setProgress: 'progress/setFlagDone'
    }),
    onSubmit(idNext) {
      this.busy = true;
      this.submitted = true;
      this.alertClear();

      this.$validator.validate()
        .then(valid => {
          if (valid) {
            return policyService.setPolicy(this.policy)
              .then(data => {
                this.setProgress('Policy' + this.id + 'Set');
                this.$router.push({ name: idNext ? 'PolicyEdit' : 'PolicyList', params: { id: idNext } });
              })
              .catch(err => {
                this.alertException({ err, message: 'Error saving policy.' });
              });
          } else {
            this.alertError('Please complete policy information and submit again.');
          }
        })
        .finally(() => {
          this.busy = false;
        });
    },
    onLoad() {
      this.ready = false;

      if (this.id) {
        policyService.getPolicy(this.id)
          .then(data => {
            // set any defaults that are missing from data to the default values
            this.policy = { ...this.$options.data.apply(this).policy, ...data };
          })
          .catch(err => {
            this.alertException({ err, message: 'Error loading policy.' });
          }).finally(() => {
            this.ready = true;
          });
      } else {
        this.alertError('Invalid policy.');
        this.ready = true;
      }
    }
  },
  created() {
    return this.onLoad();
  },
  watch: { // you have to use function syntax here, as warned in the docs
    '$route.params.id': function (newVal, oldVal) {
      this.onLoad();
    }
  }
}
</script>
